export enum DriverAdminStatusesEnum {
  Activated = 'ACTIVATED',
  Suspended = 'SUSPENDED',
  Deactivated = 'DEACTIVATED',
  Penalty = 'PENALTY',
  SuspendedB2B = 'SUSPENDED_B2B',
}
